export const numberMaskWithDecimal = (decimalLimit = 2) => {
  return 'separator.' + decimalLimit.toString();
};
